import React from "react";
import PropTypes from "prop-types";
import useCatalogProductSlots from "../../core/use-catalog-product-slots.jsx";
import styles from "./CartDrawerVerticalProductLayout.module.css";

/** Compact vertical card for static cart drawer upsell (narrow drawer width). */
export default function CartDrawerVerticalProductLayout(props) {
  const { productIndex } = props;

  const { imageBlock, metaBlock, controlsBlock, cardShellStyle } = useCatalogProductSlots({
    ...props,
    isHorizontal: false,
    layoutProfile: "cart-drawer-vertical",
    mobileCardDensity: "single",
  });

  return (
    <article
      className={styles.root}
      style={cardShellStyle}
      data-product-index={productIndex}
      data-shell-layout="cart-drawer-vertical-v1"
    >
      <div className={styles.imageSlot}>{imageBlock}</div>
      <div className={styles.metaSlot}>{metaBlock}</div>
      <div className={styles.actionsSlot}>{controlsBlock}</div>
    </article>
  );
}

CartDrawerVerticalProductLayout.propTypes = {
  section: PropTypes.object,
  productData: PropTypes.object,
  productIndex: PropTypes.number,
  popupData: PropTypes.object,
  isMobile: PropTypes.bool,
};
